// X counts too: it is a valid bank branch character.
const DIGIT_PATTERN = /[\dXx]/;

export const countDigitsBeforeIndex = (value, index) => {
  let count = 0;
  const limit = Math.min(index, value.length);

  for (let i = 0; i < limit; i += 1) {
    if (DIGIT_PATTERN.test(value[i])) count += 1;
  }

  return count;
};

export const findIndexAfterNDigits = (value, digitCount) => {
  if (digitCount <= 0) return 0;

  let seen = 0;
  for (let i = 0; i < value.length; i += 1) {
    if (DIGIT_PATTERN.test(value[i])) {
      seen += 1;
      if (seen === digitCount) return i + 1;
    }
  }

  return value.length;
};
